import { CSV_GQL } from './gql';
import { apolloClient } from '../client';

// ToDo: types
export const csvQuery = async (): Promise<any> => {
  const response = await apolloClient.query({
    query: CSV_GQL,
    variables: {},
  });

  return response.data?.books;
};
